import Spinners from 'components/Common/Spinner';
import TableContainer from 'components/Common/TableContainer';
import moment from 'moment';
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Input } from 'reactstrap';
import { getAllGatePassRequest, updateAdminGatePassRequest, updateGatePassRequest } from 'store/actions';

const GatePassApprovals = () => {

    const dispatch = useDispatch();
    const { gatePassRequestList, loading, message, error, isCreated } = useSelector(state => state.GatePassReducer);




    const changeGatePassStatus = (data) => {
        dispatch(updateAdminGatePassRequest({
            "id": data.id,
            "approved_at": new Date(),
            "status": data.status
        }))
    }

    const calculateHours = (time1, time2) => {

        const startTime = new Date(time1);
        const endTime = new Date(time2);

        const diffMs = endTime - startTime; // difference in milliseconds
        const diffHours = diffMs / (1000 * 60 * 60); // convert ms to hours

        const roundedHours = diffHours.toFixed(2); // String with 2 decimal places

        // Pad with leading zero if needed
        return roundedHours < 10 ? `0${roundedHours}` : roundedHours;

    }


    const columns = useMemo(
        () => [
            {
                Header: () => <div style={{ color: "#111" }}>#</div>,
                accessor: "id",
                filterable: true,
                Cell: ({ row, rows }) => {
                    const rowIndex = rows.indexOf(row) + 1
                    return rowIndex
                },
            },
            {
                Header: () => <div style={{ color: "#111" }}>Request</div>,
                accessor: "created_date",
                filterable: true,
                Cell: ({ value }) => moment(value).format("DD/MM/YYYY") || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>Staff</div>,
                accessor: "staff_name",
                filterable: true,
                Cell: ({ value }) => value || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>Reason</div>,
                accessor: "reason",
                filterable: true,
                Cell: ({ value }) => value || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>CheckOut</div>,
                accessor: "requested_checkout",
                filterable: true,
                Cell: ({ value }) => moment(value).format("DD/MM/YYYY") || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>CheckIn</div>,
                accessor: "requested_checkin",
                filterable: true,
                Cell: ({ value }) => moment(value).format("DD/MM/YYYY") || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>hours</div>,
                accessor: "xyz",
                filterable: true,
                Cell: ({ value, row }) => {
                    const checkin = row.original.requested_checkin;
                    const checkout = row.original.requested_checkout; // Replace with your actual accessor

                    return calculateHours(checkout, checkin) || "";
                },
            },
            {
                Header: () => <div style={{ color: "#111" }}>Status</div>,
                accessor: "status",
                filterable: true,
                Cell: ({ value, row }) => (
                    <Input
                        type='select'
                        value={value}
                        onChange={(e) => changeGatePassStatus({ status: e.target.value, id: row.original.id })}>
                        <option value={"Checked-In / Completed"}>Checked-In / Completed</option>
                        <option value={"Approved"}>Approved</option>
                        <option value={"Pending"}>Pending</option>
                        <option value={"Checked-Out"}>Checked-Out</option>
                    </Input>
                ),
            },


        ],
        [gatePassRequestList]
    );

    useEffect(() => {
        dispatch(getAllGatePassRequest())
    }, [])

    useEffect(() => {
        if (isCreated) dispatch(getAllGatePassRequest())
    }, [isCreated])

    return (
        <div className='page-content'>
            <div>
                <h5 className='text-primary'>Gate Pass Approvals</h5>
            </div>


            {loading ? (
                <Spinners />
            ) : (
                <TableContainer
                    columns={columns}
                    data={gatePassRequestList}
                    isGlobalFilter={true}
                    isAddOptions={false}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={100}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                />
            )}
        </div>
    )
}

export default GatePassApprovals